import { useContext, useEffect } from "react"
import { SupportContext } from "../../../hoc/SupportContext"
import { Link } from "react-router-dom"
import { mergeClassNames } from "../../utils/utils"
import { ChevronDownIcon } from '@heroicons/react/24/outline';



const TicketTabs = () => {
    const { ticketsCount, handleSwitchTab, tabs, countTicket, selectedProduct } = useContext(SupportContext)

    useEffect(() => {
        //fetchData("Open");
        countTicket()
    }, [selectedProduct]);

    return (
        <div className="mx-auto">
            <div className="grid grid-cols-1 sm:hidden">
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select
                    defaultValue={tabs.find((tab) => tab.current)?.name}
                    aria-label="Select a tab"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>
                <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
                />
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                        {ticketsCount.map((tab) => (
                            <Link
                                key={tab.name}
                                href="#"
                                aria-current={tab.current ? 'page' : undefined}
                                className={mergeClassNames(
                                    tab.current
                                        ? 'border-indigo-500 text-indigo-600'
                                        : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
                                    'flex whitespace-nowrap border-b-2 px-6 py-6 text-sm font-medium',
                                )}

                                onClick={() => handleSwitchTab(tab.name)}
                            >
                                {tab.name}
                                {tab.count ? (
                                    <span
                                        className={mergeClassNames(
                                            tab.current ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-100 text-gray-900',
                                            'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block',
                                        )}
                                    >
                                        {tab.count}
                                    </span>
                                ) : null}
                            </Link>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default TicketTabs